
// Main imports
import React from 'react';
import PageTitle from '../../components/PageTitle/PageTitle';
import moment from 'moment';
import Cookies from 'universal-cookie';
import { NineCellLoading } from 'react-loadingg';

// Local
import img from '../../images/background_image.png';
import getLezioni from '../../services/getLezioni';
import getStudenti from '../../services/getStudenti';
import getCorsi from '../../services/getCorsi';
import getRataStatusAll from '../../services/getRataStatusAll';

// Firebase
import { initializeApp } from 'firebase/app';
import { getAnalytics, setUserProperties } from "firebase/analytics";
import checkUtente from '../../services/checkUtente';
import getCurrentConfigurazione from '../../services/getCurrentConfigurazione';
import ScheduleView from '../../widgets/ScheduleView';
import StudentLessonInfoWidget from '../../widgets/studentLessonInfoWidget';
import AdWidget from '../../widgets/AdWidget';
import translateString from '../../utils/Locales';

/* const firebaseConfig = {
    apiKey: "AIzaSyCZhvxNOXSc5Q-Av_d9f6SEDqpubRBH8-4",
    authDomain: "appiusacademy-3f9ab.firebaseapp.com",
    projectId: "appiusacademy-3f9ab",
    storageBucket: "appiusacademy-3f9ab.appspot.com",
    messagingSenderId: "656471515583",
    appId: "1:656471515583:web:cfda849907d76522d5410a",
    measurementId: "G-TJ2W895RG5"
}; */

/* const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app); */
let t = translateString;

export default class StudentDashboard extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: true,
            warningToShow: false,
            isSmallDevice: false,
        };
    }

    handleResize() {
        if (window.innerWidth <= 785) {
            this.setState({ isSmallDevice: true });
        } else {
            this.setState({ isSmallDevice: false });
        }
    }

    async componentDidMount() {

        window.addEventListener('resize', this.handleResize.bind(this))
        this.handleResize();

/*         setUserProperties(analytics, { site_user_logged: true, main_user: false, user_registered_demo: true });
 */        
        const cookies = new Cookies();
        const username = cookies.get('username', { path: '/' });
        const token = cookies.get('token', { path: '/' });

        this.utente = await checkUtente(username, token, username);
        this.lezioni = await getLezioni(username, token);
        this.studenti = await getStudenti(username, token);
        this.corsi = await getCorsi(username, token);
        this.rate = await getRataStatusAll(username, token);
        console.error(this.rate);
        this.rate = this.rate.filter((rata) => rata.status == 'DA VERIFICARE');
        this.configurazione = await getCurrentConfigurazione(username, token, cookies.get('db', { path: '/'}));
        this.configurazione = this.configurazione.configurazioni;

        this.currUtente = this.studenti.filter((studente) => studente.id === this.utente[0].user_id)[0];
        this.corsi = this.corsi.filter((corso) => this.currUtente.corsi.indexOf(corso.id+';') != -1);

        this.todayLezioni = [];
        this.lezioni = this.lezioni.filter(l => l.data.includes(moment().format('yyyy-MM-DD')));
        this.lezioni.forEach((lezione) => {
            var corsi = [];
            corsi.push(lezione.id_corso);
            if (lezione.altri_corsi.includes(';')) lezione.altri_corsi.split(';').forEach(c => corsi.push(c));
            
            var added = false;
            corsi.forEach(corso => {
                if (!added && this.currUtente.corsi.indexOf(corso+';') != -1 && this.currUtente.corsi_ritiro.indexOf(corso+';') == -1) {
                    this.todayLezioni.push(lezione);
                    added = true;
                }
            });
        });

        this.rateNP = this.rate.filter((rata) => rata.id_studente === this.currUtente.id && rata.status == 'NON PAGATA');
        this.rateDV = this.rate.filter((rata) => rata.id_studente === this.currUtente.id && rata.status == 'DA VERIFICARE');;

        this.setState({ isLoading: false });

    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize.bind(this));
    }

    render () {

        if (this.state.isLoading) return <NineCellLoading style={{ position: 'absolute', left: '55%', top: '50%' }} />

        return(
            <>
                <PageTitle title={ t('ciao') + ' ' + this.currUtente.nome } style={{marginLeft: '0.7%'}} />
                <div style={{ display: this.state.isSmallDevice ? 'inherit' : 'flex', width: '100%', marginTop: this.state.isSmallDevice ? 0 : -30, flex: 1 }}>
                    <div style={{...dashboardView, backgroundColor: '#59A6DF', width: this.state.isSmallDevice ? '100%' : '30%', marginLeft: this.state.isSmallDevice ? '0.7%' : '0.7%', marginTop: this.state.isSmallDevice ? '5px' : '20px' }}>
                        <div style={{ display: 'flex', flex: 1, width: '100%' }}>
                            <img alt="" src={ require('../../images/lessons_icon.png') } color='#FFFFFF' style={{ position: 'relative', left: '30px', top: '20px', maxHeight: '30px', maxWidth: '30px', flex: 1 }} />
                            <p style={{ color: 'white', fontSize: '1.2rem', flex: 1, marginLeft: 45, marginTop: 20, fontFamily: 'Rubik', }}><b>{t('tuoi_corsi') + t('e_lez')}</b></p>
                        </div>
                        <p style={{ color: 'white', fontSize: '1rem', flex: 1, marginLeft: 45, marginTop: 0 }}><b>{this.corsi.length}</b> { this.corsi.length === 1 ? t('corso').toLowerCase() : t('corsi').toLowerCase() }</p>
                        <p style={{ color: 'white', fontSize: '1rem', flex: 1, marginLeft: 45, marginTop: -10 }}><b>{this.todayLezioni.length}</b> { this.todayLezioni.length === 1 ? t('lezione').toLowerCase() : t('lezioni').toLowerCase() } {t('oggi')}</p>
                    </div>
                    { this.configurazione.student_pagamenti === '1' && 
                        <div style={{...dashboardView, backgroundColor: '#7DDE77', width: this.state.isSmallDevice ? '100%' : '30%', marginTop: this.state.isSmallDevice ? '5px' : '20px', marginLeft: this.state.isSmallDevice ? '0.7%' : '1.5%' }}>
                            <div style={{ display: 'flex', flex: 1, maxWidth: '100%' }}>
                                <img alt="" src={ require('../../images/billing_icon.png') } color='#FFFFFF' style={{ position: 'relative', left: '30px', top: '20px', maxHeight: '30px', maxWidth: '30px', flex: 1 }} />
                                <p style={{ color: 'white', fontSize: '1.2rem', flex: 1, marginLeft: 45, marginTop: 20, fontFamily: 'Rubik', maxWidth: '80%' }}><b>{t('tuoi_pagamenti')}</b></p>
                            </div>
                            <p style={{ color: 'white', fontSize: '1rem', flex: 1, marginLeft: 45, marginTop: 0 }}><b>{this.rateNP.length}</b> { this.rateNP.length === 1 ? t('rata') : t('rate') } { this.rateNP.length === 1 ? t('non_pagata') : t('non_pagate') }</p>
                            <p style={{ color: 'white', fontSize: '1rem', flex: 1, marginLeft: 45, marginTop: -10 }}><b>{this.rateDV.length}</b> { this.rateDV.length === 1 ? t('rata') : t('rate') } {t('in_verifica')}</p>
                        </div>
                    }
                </div>
                <p style={{ fontFamily: 'Teko', fontSize: 20, fontColor: 'darkgrey', marginTop: 40, marginLeft: '0.7%' }}>{t('lezioni_di_oggi')}</p>
            
                <ScheduleView 
                    key={Math.random()}
                    readonly={true}
                    breaks={undefined} 
                    timePrecision={15}
                    date={moment().format('yyyy-MM-DD')} 
                    parent={this}
                    lezioni={this.todayLezioni}
                    type={''}
                    subject={this.currUtente}
                    insegnanti={undefined}
                    onMouseClick={(date, time) => {
                        
                        let clickedDate = moment(date + ' ' + time, 'yyyy-MM-DD HH:mm');
                        var found = false;
                        this.todayLezioni.forEach((lezione) => {
                            if(!found) {

                                let startDate = moment(lezione.data, 'yyyy-MM-DD HH:mm');
                                let endDate = moment(lezione.data, 'yyyy-MM-DD HH:mm').add(parseInt(lezione.durata), 'minutes');

                                if (startDate <= clickedDate && endDate >= clickedDate) {
                                    this.setState({ lezione: lezione, showLessonInfo: true });
                                    found = true;
                                }
                            }
                        })
                    }}
                />

                { this.state.showLessonInfo && (
                    <StudentLessonInfoWidget 
                        lezione={this.state.lezione}
                        show={this.state.showLessonInfo}
                        onClose={() => { this.setState({ showLessonInfo: false }) }}
                    />
                )}

                <AdWidget bottomWidget={true} />

            </>
        );
    }
}

const dashboardView = {
    width: '30%', 
    minHeight: '80px', 
    marginLeft: '1.5%', 
    marginTop: '20px', 
    borderRadius: '10px', 
    border: '1px solid lightgrey',
    boxShadow: '0px 2px 10px lightgrey',
    flex: 1,
    backgroundImage: `url(${img})`,
    backgroundSize: '100% auto',
    backgroundRepeat: 'no-repeat',
    padddingLeft: '10px', 
    paddingRight: '10px',
    overflow: 'hidden',
};

const widgetTitle = {
    fontWeight: 'bold',
    fontFamily: 'Rubik', 
    fontSize: 30,
    marginBottom: 30,
    marginTop: 15,
    position: 'relative', 
    top: 5, 
    left: 45,
    color: '#A7A7A7',
};

const widgetView = {
    width: '99.3%', 
    marginLeft: '0.7%', 
    backgroundColor: 'white', 
    boxShadow: '0px 2px 10px lightgrey', 
    border: '0px solid lightgrey',
    marginTop: 20,
    flex: 1, 
    borderRadius: '10px',
    overflow: 'hidden', 
    paddingBottom: '10px',
};